
export enum LoginResponseType {
  LOGIN = 'LOGIN',
  REDIRECT = 'REDIRECT',
  SERVER_ERROR = 'SERVER_ERROR'
}
